import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-notification-counter',
  template: `
    <div *ngIf="count || displayOnZero" class="counter-badge">
        <span>{{ count }}</span>
    </div>
  `,
  styleUrls: ['./notification-counter.components.scss']
})
export class NotificationCounterComponent {
  @Input() count: number;
  @Input() displayOnZero = false;
}
